import { render, staticRenderFns } from "./SortGoods.vue?vue&type=template&id=0a6ce9c3&scoped=true&"
import script from "./SortGoods.vue?vue&type=script&lang=js&"
export * from "./SortGoods.vue?vue&type=script&lang=js&"
import style0 from "./SortGoods.vue?vue&type=style&index=0&id=0a6ce9c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6ce9c3",
  null
  
)

export default component.exports